import {useState,useEffect} from "react";
import ImageWithBasePath from '../../core/img'
import {all_routes} from '../router/all_routes'
import {Link} from 'react-router-dom'
/* -- biz9 import start -- */
import {UrlQuery} from "biz9-react-utility";
import {Log} from "biz9-utility";
import {Field,Message,Title,Type,Url} from "../../constant";
import {App,Data,Dashboard,Event,Field_Logic,Image,Style,Service_Industry,Template,Toast_Message,Storage,System,User} from "../../project";
import {Review_Table,Review_Url} from "biz9-review";
import {Data_Logic} from "biz9-data-app";
import {Image_Format} from "biz9-image";
import {User_Logic} from "biz9-user";
 import SubValue from "../subValue";
 import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";

/* -- biz9 import end -- */
const Testimonials = () => {
    const routes = all_routes;
	const query = UrlQuery();
    // -- page-edit --
 const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
 const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
 const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
 const [edit_mode,setEditMode] = useState(false);


    const [reviews,setReviews]= useState([]);
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_page_data();
    }, []);
    //
    useEffect(() => {
        Toast_Message.loading(Message.LOADING);
        get_data();
    }, []);

    async function get_page_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.REVIEW_HOME.title_url,option);
        bind_page(data);
    };
    async function get_data() {
        // -- remote-data-response --
        let option = {get_cache:false,time_limit:10};
        const [response,data] = await Portal_Remote_Page.get_home_items(App.get_url(Portal_Page.REVIEW_HOME[Portal_Type.ITEMS_URL]),option);
        bind_items(data);
        Toast_Message.dismiss();
    }
    async function bind_page(data) {
        // -- page-template --
        setPage(data[Portal_Type.PAGE]);
        // -- page-edit --
        setEditMode(query.get('edit_mode'));
        setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
        // -- sub-values --
        bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
    };
	async function bind_items(data) {
        // -- items --
        setReviews(data[Portal_Type.REVIEWS]);
	}
    //* ---- BIND-SUB-VALUES ----
    async function bind_sub_values(data_sub_group) {
        // -- sub-values --
        for(const sub_group in data_sub_group){
            if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
            }else{
                sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
            }
        }
        Storage.post_sub_value_group(sub_value_edit,data_sub_group);
    };
    //* ---- UPDATE-SUB-VALUE ----
     async function update_sub_value(sub_value) {
        // -- page-edit-sub-values --
        if(sub_value.type != Sub_Value_Type.ITEMS){
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    value: sub_value.value
                }
            }));
        }else{
            setSubValueGroup(sub_value_group => ({
                ...sub_value_group,
                    [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                    ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                    items: sub_value.items
                }
            }));
        }
    }



   return (
    <>
  {/* Breadcrumb */}
  <div className="breadcrumb-bar breadcrumb-bar-info">
    <div className="breadcrumb-img">
      <div className="breadcrumb-left">
        <ImageWithBasePath src="/assets/img/bg/banner-bg-03.png" alt="img" />
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-md-12 col-12">
          <nav aria-label="breadcrumb" className="page-breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={all_routes.home}>Home</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
    {sub_value_group.sub_value_1.value}
              </li>
            </ol>
          </nav>
          <h2 className="breadcrumb-title mb-0">
         {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
    {sub_value_group.sub_value_1.value}
      <span className="text-primary" />
          </h2>
        </div>
      </div>
    </div>
  </div>
  {/* /Breadcrumb */}
  {/* Content */}
        <div className="text-center mt-3">
            <Link to={all_routes.review_edit} className="btn btn-dark text-white">
              {"Write Us A Review"}
            </Link>
          </div>

  <div className="page-content content">
    <div className="container">
      <div className="row">
        {/* Testimonial -1 */}
     {reviews.map((item) => (
        <div className="col-xl-4 col-lg-6 col-md-6">
          <div className="testimonial-slider-card">
            <div className="testimonial-item">
              <div className="testimonial-icon">
                <i className="ti ti-quote-filled" />
              </div>
              <h5 className="mb-2">{item.title}</h5>
              <p className="mb-3">
                {item.comment}
            </p>
              <div className="testimonial-review d-flex align-items-center justify-content-between">
                <div className="testimonial-user p-0">
                  <ImageWithBasePath src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} alt="img" />
                  <div className="testimonial-info">
                    <h6>{item.user.title}</h6>
                    <p>{User_Logic.get_country_state_city(item.user)}</p>
                  </div>
                </div>
                <div className="star-rate m-0 bg-light">
                  <span>
                    {Array.from({ length: parseInt(item.rating) }).map((_, index) => (
                    <i className="fa-solid fa-star filled" />
                    ))}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
     ))}
        {/* /Testimonial -1 */}
      </div>
    </div>
  </div>
  {/* /Content */}
</>
  )
}
export default Testimonials
